import { notifications } from '@mantine/notifications';
import { useMutation } from '@tanstack/react-query'

// SCD-600: routeName lets the CMS Logo step reach the same controller on its own
// domain — the studio.v1 route is bound to the Ad Studio host and 404s on the CMS one.
export const mutateLogoPlate = ({ routeName = 'studio.v1.api.logo_plate.store', ...initParams } = {}) => {

    const mutation = useMutation({
        mutationKey: ['logo-plate', routeName, initParams],
        mutationFn: async (params) => {
            const res = await axios.post(route(routeName), params);
            return res;
        },
        onError: async ({ response }) => {

            notifications.show({
                color: 'red',
                title: 'Error',
                message: response?.data?.message || "",
            })
        }
    });

    return mutation;
}
